var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6668 2.0013H13.3335C14.0668 2.0013 14.6668 2.6013 14.6668 3.33464V14.0013C14.6668 14.7346 14.0668 15.3346 13.3335 15.3346H2.66683C1.9335 15.3346 1.3335 14.7346 1.3335 14.0013V3.33464C1.3335 2.6013 1.9335 2.0013 2.66683 2.0013H3.3335V1.33464C3.3335 0.967969 3.6335 0.667969 4.00016 0.667969C4.36683 0.667969 4.66683 0.967969 4.66683 1.33464V2.0013H11.3335V1.33464C11.3335 0.967969 11.6335 0.667969 12.0002 0.667969C12.3668 0.667969 12.6668 0.967969 12.6668 1.33464V2.0013ZM3.3335 14.0013H12.6668C13.0335 14.0013 13.3335 13.7013 13.3335 13.3346V5.33464H2.66683V13.3346C2.66683 13.7013 2.96683 14.0013 3.3335 14.0013Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5a08275186f4af2b1f170a157b7ecc30.svg";
export { ForwardRef as ReactComponent };